import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect';
import Utility from '../../../services/utility.service';

export default {
  name: 'createtspbausers',
  components: {
    Paginate,
    BasicSelect,
    Multiselect,
    VueElementLoading
  },
  props: ['selectedEditRowData'],
  data () {
    return {
      isLoading:false,
      userid:'',
      username:'',
      email:'',
      password:'',
      olddeliveryuserid:'',
      loggedinuserName:'',
      status: '',
      statuslist:[{
        value : "1",
        text : 'Active'
      },{
        value : "0",
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
      createflag: 1
    }
  },
  computed: {
  },
  async mounted () {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.loggedinuserName = userdetail.email;
    if(this.selectedEditRowData.userid){
      this.createflag = 0;
      this.userid = this.selectedEditRowData.userid;
      this.username = this.selectedEditRowData.username;
      this.email = this.selectedEditRowData.email;
      this.olddeliveryuserid = this.selectedEditRowData.VendorId;
      this.status = (this.selectedEditRowData.status)?1:0;
      if(this.selectedEditRowData.status){
        this.statusitem = { value : "1", text : 'Active' }
      }else{
        this.statusitem = { value : "0", text : 'Inactive' }
      }
    }
  },
  methods: {
    isIntegerOnlty: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
    showtspbausersData() {
      this.$emit("goBackToParent")
    },
    async saveTSPBAUserDetails(){
      try {
        var inputPayload = {};
        if(this.userid){
          inputPayload.userid = this.userid;
        }
        inputPayload.username = this.username;
        inputPayload.email = this.email;
        if(this.createflag){
          inputPayload.password = this.password;
        }
        inputPayload.olddeliveryuserid = this.olddeliveryuserid;
        inputPayload.status = this.status;
        inputPayload.lastmodifiedby = this.loggedinuserName;
        this.isLoading = true;
        let result = await Utility.saveTSPBAUserDetails(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, this.username, "success");
          this.$emit("goBackToParent");
        }else{
          this.$alert(result.data.message, this.username, "error");
        }
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    onSubmit: function() {
      var self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saveTSPBAUserDetails(event);
        }else{
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
  }
}

Validator.extend('verifypassword', {
    getMessage: field => "The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character and minimum 8 and maximum 16 characters.",
    validate: value => {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,16}$)");
        return strongRegex.test(value);
    }
});



// WEBPACK FOOTER //
// ./src/modules/utility/views/tspbausers/createtspbausers/createtspbausers.component.js